// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".type-icon[data-v-209bc1de]{max-height:1.5em}", "",{"version":3,"sources":["webpack://./resources/js/dipocaco/components/parts/TypeIcon.vue"],"names":[],"mappings":"AACA,4BACI,gBAAA","sourcesContent":["\n.type-icon {\n    max-height: 1.5em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
